import React from 'react';
import PropTypes from 'prop-types';

import { CalloutStoreProvider } from './callout-store';
import { CalloutService } from './callout-service';
import { getAllCallout } from './config';

export const CalloutView = ({ props }) => {
  const calloutListConfig = getAllCallout(props);

  return (
    <CalloutStoreProvider calloutListConfig={calloutListConfig}>
      <CalloutService />
    </CalloutStoreProvider>
  );
};

CalloutView.propTypes = {
  props: PropTypes.shape({}).isRequired,
};
